import { enqueueSnackbar, DownloadFile } from 'actions';
import {
	ooImportRequest, ooImportSuccess, ooImportFailure,
	ooGetLastUpdateRequest, ooGetLastUpdateSuccess, ooGetLastUpdateFailure,
	ooCompletionOverdueRequest, ooCompletionOverdueSuccess, ooCompletionOverdueFailure,
	ooEndingTodayRequest, ooEndingTodaySuccess, ooEndingTodayFailure,
	ooPartnerRestrictedRequest, ooPartnerRestrictedSuccess, ooPartnerRestrictedFailure,
	ooPartnerRestrictedBlacklistRequest, ooPartnerRestrictedBlacklistSuccess, ooPartnerRestrictedBlacklistFailure,
	ooPartnersEmailsRequest, ooPartnersEmailsSuccess, ooPartnersEmailsFailure,
} from '../actions/oldOutagesActions';
import {
	OoImportFileRequest,
	OoGetLastUpdateRequest,
	OoCompletionOverdueRequest,
	OoEndingTodayRequest,
	OoPartnerRestrictedRequest,
	OoPartnerRestrictedBlacklistRequest,
	OoPartnersEmailsRequest,
} from '../requests/oldOutagesRequests';

// ─── GET LAST UPDATE ──────────────────────────────────────────────────────────

export const ooGetLastUpdate = () => async (dispatch) => {
	dispatch(ooGetLastUpdateRequest());
	await OoGetLastUpdateRequest().then((response) => {
		const raw = response.data?.oldOutagesLastUpdate ?? response.data?.OldOutagesLastUpdate;
		dispatch(ooGetLastUpdateSuccess({
			user:      raw?.insertUser  ?? raw?.InsertUser  ?? null,
			timestamp: raw?.insertDate  ?? raw?.InsertDate  ?? null,
		}));
	}).catch((error) => {
		dispatch(ooGetLastUpdateFailure(error?.message));
	});
};

// ─── IMPORT FILE ──────────────────────────────────────────────────────────────

export const ooImportFile = (userId, file) => async (dispatch) => {
	dispatch(ooImportRequest());
	await OoImportFileRequest(userId, file).then((response) => {
		dispatch(ooImportSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'File imported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(ooImportFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── COMPLETION OVERDUE ───────────────────────────────────────────────────────

export const ooCompletionOverdue = (userId, userEmail, testEmails) => async (dispatch) => {
	dispatch(ooCompletionOverdueRequest());
	await OoCompletionOverdueRequest(userId, userEmail, testEmails).then((response) => {
		dispatch(ooCompletionOverdueSuccess(response.data));
		const label = testEmails ? 'Test emails sent successfully.' : 'Emails sent successfully.';
		dispatch(enqueueSnackbar({ message: label, options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(ooCompletionOverdueFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── ENDING TODAY ─────────────────────────────────────────────────────────────

export const ooEndingToday = (userId, userEmail, testEmails) => async (dispatch) => {
	dispatch(ooEndingTodayRequest());
	await OoEndingTodayRequest(userId, userEmail, testEmails).then((response) => {
		dispatch(ooEndingTodaySuccess(response.data));
		const label = testEmails ? 'Test emails sent successfully.' : 'Emails sent successfully.';
		dispatch(enqueueSnackbar({ message: label, options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(ooEndingTodayFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── PARTNER RESTRICTED ───────────────────────────────────────────────────────

export const ooPartnerRestricted = (userId, userEmail, testEmails) => async (dispatch) => {
	dispatch(ooPartnerRestrictedRequest());
	await OoPartnerRestrictedRequest(userId, userEmail, testEmails).then((response) => {
		dispatch(ooPartnerRestrictedSuccess(response.data));
		const label = testEmails ? 'Test emails sent successfully.' : 'Emails sent successfully.';
		dispatch(enqueueSnackbar({ message: label, options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(ooPartnerRestrictedFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── PARTNER RESTRICTED BLACKLIST ─────────────────────────────────────────────

export const ooPartnerRestrictedBlacklist = (userId, userEmail, testEmails) => async (dispatch) => {
	dispatch(ooPartnerRestrictedBlacklistRequest());
	await OoPartnerRestrictedBlacklistRequest(userId, userEmail, testEmails).then((response) => {
		dispatch(ooPartnerRestrictedBlacklistSuccess(response.data));
		const label = testEmails ? 'Test emails sent successfully.' : 'Emails sent successfully.';
		dispatch(enqueueSnackbar({ message: label, options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(ooPartnerRestrictedBlacklistFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── PARTNERS EMAILS ──────────────────────────────────────────────────────────

export const ooPartnersEmails = (userId, userEmail, testEmails) => async (dispatch) => {
	dispatch(ooPartnersEmailsRequest());
	await OoPartnersEmailsRequest(userId, userEmail, testEmails).then((response) => {
		dispatch(ooPartnersEmailsSuccess(response.data));
		const label = testEmails ? 'Test emails sent successfully.' : 'Emails sent successfully.';
		dispatch(enqueueSnackbar({ message: label, options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(ooPartnersEmailsFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};